"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DirectionLeft_1 = require("../Icons/DirectionLeft");
var DirectionRight_1 = require("../Icons/DirectionRight");
var NormalClose_1 = require("../Icons/NormalClose");
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var PromptErrorFill_1 = require("../Icons/PromptErrorFill");
var PromptInfoCircleFill_1 = require("../Icons/PromptInfoCircleFill");
var scrollAnimation_1 = tslib_1.__importDefault(require("./scrollAnimation"));
var index_1 = tslib_1.__importDefault(require("./index"));
var CarouselNoticebarList = function (props) {
    var dataSource = props.dataSource, global = props.global, className = props.className, style = props.style;
    var _a = tslib_1.__read((0, react_1.useState)(0), 2), currentIndex = _a[0], setCurrentIndex = _a[1];
    var _b = tslib_1.__read((0, react_1.useState)(false), 2), switching = _b[0], setSwitching = _b[1];
    var _c = tslib_1.__read((0, react_1.useState)(0), 2), switchingIndex = _c[0], setSwitchingIndex = _c[1];
    var maxLen = dataSource.length;
    var carouselInnerRef = (0, react_1.useRef)(undefined);
    var timer = (0, react_1.useRef)(null);
    var indexRef = (0, react_1.useRef)(0);
    var getNextIndex = function (index) {
        if (index < 0) {
            return maxLen - 1;
        }
        if (index >= maxLen) {
            return 0;
        }
        return index;
    };
    var resetInner = function () {
        setTimeout(function () {
            if (carouselInnerRef.current) {
                carouselInnerRef.current.style.left = '0px';
            }
        }, 0);
    };
    (0, react_1.useEffect)(function () {
        if (maxLen < currentIndex) {
            setCurrentIndex(0);
            indexRef.current = 0;
        }
        var inner = carouselInnerRef.current;
        var prevIndex = currentIndex;
        // 内容超出，需要滚动
        timer.current = (0, scrollAnimation_1.default)(inner, function () {
            // 手动操作后 不需要自动切换
            if (prevIndex === indexRef.current) {
                setSwitching(true);
                setSwitchingIndex(getNextIndex(currentIndex + 1));
                setTimeout(function () {
                    setCurrentIndex(function (cur) {
                        resetInner();
                        indexRef.current = getNextIndex(cur + 1);
                        return getNextIndex(cur + 1);
                    });
                }, 400);
                // 比切换多20ms，防止闪烁
                setTimeout(function () {
                    setSwitching(false);
                }, 430);
            }
        });
        return function () {
            clearTimeout(timer.current);
            resetInner();
        };
    }, [currentIndex, maxLen]);
    var currentItem = dataSource[currentIndex];
    (0, react_1.useEffect)(function () {
        if (!dataSource[currentIndex] && dataSource.length) {
            setCurrentIndex(0);
        }
    }, [dataSource, currentIndex]);
    if (!dataSource || !dataSource.length || !currentItem) {
        return null;
    }
    var _d = currentItem.type, type = _d === void 0 ? 'info' : _d, content = currentItem.content, _e = currentItem.closable, closable = _e === void 0 ? true : _e, closeText = currentItem.closeText, actionText = currentItem.actionText, onAction = currentItem.onAction, onClose = currentItem.onClose;
    var getIcon = function () {
        return {
            info: react_1.default.createElement(PromptInfoCircleFill_1.PromptInfoCircleFill, { className: "anq-notice-icon" }),
            warn: react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "anq-notice-icon" }),
            success: react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { className: "anq-notice-icon" }),
            error: react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "anq-notice-icon" }),
        }[type];
    };
    var getNextDom = function () {
        var nextItem = dataSource[switchingIndex];
        var _a = nextItem.type, type = _a === void 0 ? 'info' : _a, content = nextItem.content, _b = nextItem.closable, closable = _b === void 0 ? true : _b, closeText = nextItem.closeText, actionText = nextItem.actionText;
        var iconColor = {
            info: '#4c67ff',
            warn: '#ff7300',
            success: '#00b400',
            error: '#ff1818',
        }[type];
        var icon = {
            info: react_1.default.createElement(PromptInfoCircleFill_1.PromptInfoCircleFill, { className: "anq-notice-icon", style: { color: iconColor } }),
            warn: react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "anq-notice-icon", style: { color: iconColor } }),
            success: react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { className: "anq-notice-icon", style: { color: iconColor } }),
            error: react_1.default.createElement(PromptErrorFill_1.PromptErrorFill, { className: "anq-notice-icon", style: { color: iconColor } }),
        }[type];
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-notice-next-content', {
                'anq-notice-next-global-content': global,
            }) },
            icon,
            react_1.default.createElement("div", { className: "anq-notice-content", title: typeof content === 'string' ? content : null },
                react_1.default.createElement("div", { className: "anq-notice-content-inner" }, content)),
            actionText && react_1.default.createElement("div", { className: "anq-notice-action" }, actionText),
            react_1.default.createElement("div", { style: { flexGrow: 1 } }),
            closable &&
                (closeText ? (react_1.default.createElement("div", { className: "anq-notice-close" }, closeText)) : (react_1.default.createElement(NormalClose_1.NormalClose, { className: "anq-notice-close-icon" }))),
            react_1.default.createElement("div", { className: "anq-notice-dive" }),
            react_1.default.createElement("div", { className: "anq-notice-list-operate" },
                react_1.default.createElement(DirectionLeft_1.DirectionLeft, { className: "anq-notice-list-operate-icon" }),
                react_1.default.createElement("span", { className: "anq-notice-list-operate-content" },
                    switchingIndex + 1,
                    "/",
                    maxLen),
                react_1.default.createElement(DirectionRight_1.DirectionRight, { className: "anq-notice-list-operate-icon" }))));
    };
    var handleClose = function () {
        onClose && onClose();
    };
    var handleNext = function (index) {
        var i = getNextIndex(index);
        indexRef.current = i;
        clearTimeout(timer.current);
        setSwitching(true);
        setSwitchingIndex(i);
        setTimeout(function () {
            setCurrentIndex(function () {
                resetInner();
                return i;
            });
        }, 400);
        setTimeout(function () {
            resetInner();
            setSwitching(false);
        }, 430);
    };
    if (dataSource.length === 1) {
        var item = dataSource[0];
        return react_1.default.createElement(index_1.default, tslib_1.__assign({}, item, { style: style, className: className, global: global }));
    }
    var getTypeCls = function () {
        var curType = type;
        if (switching) {
            var nextItem = dataSource[switchingIndex];
            curType = nextItem.type || 'info';
        }
        return "anq-notice-".concat(global ? 'global-' : '').concat(curType);
    };
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)('anq-notice', 'anq-notice-list', className, getTypeCls(), {
            'anq-notice-large': !!global,
        }) },
        switching && getNextDom(),
        getIcon(),
        react_1.default.createElement("div", { className: "anq-notice-content", title: typeof content === 'string' ? content : null },
            react_1.default.createElement("div", { className: "anq-notice-content-inner", ref: carouselInnerRef }, content)),
        actionText && (react_1.default.createElement("div", { className: "anq-notice-action", onClick: function () { return onAction && onAction(); } }, actionText)),
        react_1.default.createElement("div", { style: { flexGrow: 1 } }),
        closable &&
            (closeText ? (react_1.default.createElement("div", { className: "anq-notice-close", onClick: handleClose }, closeText)) : (react_1.default.createElement(NormalClose_1.NormalClose, { className: "anq-notice-close-icon", onClick: handleClose }))),
        react_1.default.createElement("div", { className: "anq-notice-dive" }),
        react_1.default.createElement("div", { className: "anq-notice-list-operate" },
            react_1.default.createElement(DirectionLeft_1.DirectionLeft, { className: "anq-notice-list-operate-icon", onClick: function () { return handleNext(currentIndex - 1); } }),
            react_1.default.createElement("span", { className: "anq-notice-list-operate-content" },
                currentIndex + 1,
                "/",
                maxLen),
            react_1.default.createElement(DirectionRight_1.DirectionRight, { className: "anq-notice-list-operate-icon", onClick: function () { return handleNext(currentIndex + 1); } }))));
};
exports.default = CarouselNoticebarList;
//# sourceMappingURL=CarouselNoticebarList.js.map